module.exports = __webpack_public_path__ + "img/Fiche chargé d'organisation du tutorat.bca151ce.jpg";